/** @format */

import React from 'react';
import './styles.scss';
import PageLayout from 'components/Layout/Page';
import {
  LeadsSectionBody,
  LeadSources,
  LeadTypes
} from 'components/LeadsGenerator';

export default function LeadsSellPage(props) {
  const text = props.t('lang_common:leads_page:sell');

  const ImageSection = () => {
    return (
      <img
        src='/images/leads-sell-page.jpg'
        className='sell-page-image'
        alt='leads sell image'
      />
    );

    // return <></>;
  };
  return (
    <PageLayout mainContainerClassName='leads-page sell-page' {...props}>
      <div className='sell-page-wrapper'>
        <div className='form-section'>
          <div className='header-section'>
            <h3>{text?.heading}</h3>
            <p className='text2r'>{text?.headerParagraph}</p>
          </div>
          <LeadsSectionBody
            metadata={{
              source: LeadSources.FM_HOME
            }}
            defaultLeadType={LeadTypes.SELL}
            {...props}
          />
        </div>
        <div className='image-section'>
          <ImageSection />
        </div>
      </div>
    </PageLayout>
  );
}
